module.exports = __webpack_public_path__ + "static/media/HomeStoryLogo5.8c33ae7b.png";